// QA-only mock for the relationship-strength intro-paths surface. Enabled via
// `localStorage.rsMock = '1'` (or `?rsMock=1`; the SPA router strips the param,
// so localStorage is the reliable toggle). Synthesises a per-path `level`, person
// `emails`, origin integration flags, and signal evidence so the enriched card
// (badge + met-criteria + email button + connect/copy nudge) can be exercised
// against any collection, flagged or not.
//
// Keys are camelCase because the network base query camelCases the response
// before this runs.

const LEVELS = ['warm', 'known', 'cold', 'inferred', 'unknown'];

export const isConnectionPathsMockEnabled = () => {
  try {
    if (typeof window === 'undefined') return false;
    if (new URLSearchParams(window.location.search).has('rsMock')) return true;
    return window.localStorage?.getItem('rsMock') === '1';
  } catch {
    return false;
  }
};

const mockSignal = (idx) =>
  idx === 0
    ? { kind: 'signal', type: 'linkedin_connection', connectedAt: 1577836800000 }
    : {
        kind: 'signal',
        type: 'work_overlap',
        organizationName: 'Globex',
        overlapFrom: '2019-01-01',
        overlapTo: '2021-06-01',
        bothCurrentlyAtCompany: false,
      };

// Written where the API puts them so the mock drives the same read path.
const withMockEmails = (node, emails) => {
  const resource = node[node.kind];
  if (!resource?.data) return node;

  const attributes = resource.data.attributes || {};
  if (attributes.emails?.length) return node;

  return {
    ...node,
    [node.kind]: { ...resource, data: { ...resource.data, attributes: { ...attributes, emails } } },
  };
};

const decorateItem = (item, i) => {
  const persons = (item.path || []).filter((n) => n.kind === 'user' || n.kind === 'contact');
  if (persons.length === 0) return item;

  const path = [];
  persons.forEach((person, idx) => {
    const address = `${person.kind}-${person.id}@example.com`;
    // Vary by path and position so both the mailto and dropdown variants appear.
    const emails = (i + idx) % 2 === 0 ? [address] : [address, `${person.kind}-${person.id}.alt@example.com`];
    const node = withMockEmails({ ...person }, emails);
    if (idx === 0) node.linkedinConnected = false; // origin missing LinkedIn → connect/copy nudge
    path.push(node);
    if (idx < persons.length - 1) path.push(mockSignal(idx)); // signal between each pair → met-criteria rows
  });

  return { ...item, level: LEVELS[i % LEVELS.length], path };
};

export const decorateConnectionPathsMock = (items) =>
  isConnectionPathsMockEnabled() ? items.map(decorateItem) : items;
